<div class="pageheader">
  <div class="page-title">
    <h1>Format types</h1>
    <div class="btn-group">
      <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
      <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Format types log'">
        <app-change-log-link-entity type="FormatType"></app-change-log-link-entity>
      </app-change-log-link>
    </div>
  </div>
</div>

<dx-data-grid biz-grid [selection]='{ mode: "none" }' [dataSource]='formatTypes' [bizSetColumnChooser]="false" [bizSetAllowColumnReordering]="false" [bizSetPager]="false"
  (onInitNewRow)="onInitNewRow($event)" (onRowInserting)="onRowInserting($event)" (onRowUpdating)="onRowUpdating($event)" (onRowRemoving)="onRowRemoving($event)"
  (onEditingStart)="onEditingStart($event)" (onEditCanceled)="onEditCanceled()" (onRowValidating)="onRowValidating($event)" [bizEditRowOnDoubleClick]="true">

  <dxo-editing mode="popup" [allowUpdating]="allowUpdating" [allowAdding]="allowAdding" [allowDeleting]="allowDeleting">
    <dxo-form [colCount]="1">
      <dxi-item caption="General" itemType="group" [colCount]="2">
        <dxi-item dataField="Name"></dxi-item>
        <dxi-item dataField="DefaultExtension"></dxi-item>
        <dxi-item dataField="ContentTypeId"></dxi-item>
      </dxi-item>
      <dxi-item caption="Disassembling" itemType="group">
        <dxi-item dataField="DisassemblerInitStepId"></dxi-item>
      </dxi-item>
      <dxi-item caption="Probing" itemType="group">
        <dxi-item dataField="ProbeArtifactId"></dxi-item>
      </dxi-item>
    </dxo-form>
  </dxo-editing>

  <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

  <dxi-column dataField="Name" caption="Name" dataType="string" sortOrder="asc" [allowGrouping]="false">
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>

  <dxi-column dataField="DefaultExtension" caption="Default extension">
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>

  <dxi-column dataField="ContentTypeId" dataType="string" caption="Content-Type">
    <dxo-lookup [dataSource]="contentTypes" valueExpr="Id" displayExpr="Name"></dxo-lookup>
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>

  <dxi-column dataField="DisassemblerInitStepId" dataType="string" caption="Disassembler" [calculateDisplayValue]="displayExprDisassembler" editCellTemplate="disassemblerEditor">
    <dxo-header-filter [dataSource]="bizGridFiltervalues.getInitStepFilterData(bizGridFiltervalues.getPropertyValues(this.formatTypes, 'DisassemblerInitStepId'), initStepDisassemblers)" />
  </dxi-column>

  <dxi-column dataField="ProbeArtifactId" caption="Probe artifact" dataType="string" editCellTemplate="probeArtifactEditTemplate" [calculateDisplayValue]="displayExprArtifact">
    <dxo-header-filter [dataSource]="bizGridFiltervalues.getAssemblyArtifactFilterData(bizGridFiltervalues.getPropertyValues(this.formatTypes, 'ProbeArtifactId'), probeArtifacts)" />
  </dxi-column>

  <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="false"><dxo-header-filter
  [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(this.formatTypes, 'CreatedBy'))"></dxo-header-filter></dxi-column>
  <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="false" format="dateTime"></dxi-column>
  <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="true"><dxo-header-filter
  [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(this.formatTypes, 'UpdatedBy'))"></dxo-header-filter> </dxi-column>
  <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="true" format="dateTime"></dxi-column>

  <dxi-column type="buttons">
    <dxi-button name="edit"></dxi-button>
    <dxi-button name="delete"></dxi-button>
    <dxi-button text="Show Log" template="logTemplate" [visible]="allowShowLog">
    </dxi-button>
  </dxi-column>

  <ng-container *dxTemplate="let cell of 'logTemplate'">
    <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Log for ' + cell.data.Name" [showIcon]="false" classNames="dx-link">
      <app-change-log-link-entity type="FormatType" [id]="cell.data.Id"></app-change-log-link-entity>
    </app-change-log-link>
  </ng-container>

  <div *dxTemplate="let cellInfo of 'disassemblerEditor'">
    <select class="form-control" [ngModel]="selectedDisassemblerId" (ngModelChange)="disassemblerChanged($event, cellInfo)" [disabled]="isFormatTypeDisassemblerConfigurationOveridden">
      <option [ngValue]="null">Select...</option>
      @for (item of initStepDisassemblers; track item) {
        <option [ngValue]="item.Id" [title]="item.Description">
          {{item.Name}}
        </option>
      }
    </select>
    @if (isFormatTypeDisassemblerConfigurationOveridden) {
      <div>
        <span style="color: grey;">Cannot change Disassembler while a Format is overriding its configuration.</span>
      </div>
    }
    @if (disassembleDisplayGroups.length > 0) {
      <ep-datafield-group-container [formValidationGroup]="disassembleFormGroup" [showError]="true" [datafieldGroups]="disassembleDisplayGroups"
      [isAlwaysEditable]="true" [numberOfColumns]="2"></ep-datafield-group-container>
    }
  </div>

  <ng-container *dxTemplate="let cellInfo of 'probeArtifactEditTemplate'">
    <app-developer-artifact-assembly-picker [assemblyTypes]="['FormatTypeProbe', 'FormatTypeProbe2']" (selectedArtifactIdChange)="setProbeArtifactId($event, cellInfo)"
    [selectedArtifactId]="cellInfo.data.ProbeArtifactId"></app-developer-artifact-assembly-picker>
  </ng-container>
</dx-data-grid>
